import React, { Fragment, useEffect, useState } from "react"
import styled from "styled-components"

import { Location } from "@reach/router"
import { Elements, StripeProvider } from "react-stripe-elements"
import Media from "react-media"
import { ToastContainer } from "react-toastify"
import ReactTooltip from "react-tooltip"
import "react-toastify/dist/ReactToastify.min.css"
import { Subscribe } from "unstated"

import DesktopNavbar from "./DesktopNavbar"
import MobileNavbar from "./MobileNavbar"

import authStore from "../stores/auth"
import global from "../utils/windowOrGlobal"
import RealTimeNotification from "./RealTimeNotification"
import NotificationStore from "../stores/notifications"

const LayoutContainer = styled.div`
  @media screen and (min-width: 961px) {
    max-width: 930px;
    width: 90%;
    margin: 0 auto;

    .placeholder-div {
      height: 61px;
    }

    .root-child {
      min-height: 61px;
    }
  }

  @media screen and (max-width: 960px) {
    .root-child {
      padding: 1px;
      opacity: 1;
      overflow: visible;
      height: auto;
    }

    .root-childs-child {
      padding: 1px;
      min-height: 489px;
      display: block;
    }

    .placeholder-bot-nav {
      height: 80px;
    }
  }
`

const StripeWrapper = ({ children }) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    if (global.Stripe && !mounted) {
      setMounted(true)
    }
  }, [mounted, setMounted, global.Stripe])

  if (!mounted) {
    return <div>{children}</div>
  }

  return (
    <StripeProvider apiKey={process.env.STRIPE_API_KEY}>
      <Elements>{children}</Elements>
    </StripeProvider>
  )
}

function LayoutFactory(Child, props) {
  useEffect(() => {
    authStore.silentAuth()
  }, [authStore.silentAuth])

  return (
    <Location>
      {locationProps => (
        <LayoutContainer>
          <ReactTooltip effect="solid" />
          <ToastContainer
            position="top-right"
            autoClose={false}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
            enableMultiContainer
            containerId={"general"}
          />
          <Media
            queries={{
              small: "(max-width: 960px)",
            }}
          >
            {matches => {
              const isMobile = matches.small

              if (isMobile) {
                return (
                  <Fragment>
                    <div className="root-child">
                      <div className="root-childs-child">
                        <MobileNavbar
                          {...locationProps}
                          user={authStore.state.user}
                        />
                        <div className="placeholder-bot-nav" />
                        <StripeWrapper>
                          <Child
                            {...props}
                            {...locationProps}
                            isMobile={isMobile}
                            authStore={authStore}
                          />
                        </StripeWrapper>
                      </div>
                    </div>
                  </Fragment>
                )
              }

              return (
                <Fragment>
                  <div className="root-top">
                    <DesktopNavbar
                      {...locationProps}
                      user={authStore.state.user}
                    />
                  </div>
                  <div className="placeholder-div"></div>
                  <StripeWrapper>
                    <Child
                      {...props}
                      {...locationProps}
                      isMobile={isMobile}
                      authStore={authStore}
                    />
                  </StripeWrapper>
                </Fragment>
              )
            }}
          </Media>
          <Subscribe to={[NotificationStore]}>
            {notificationStore => (
              <RealTimeNotification
                notificationStore={notificationStore}
                authStore={authStore}
              />
            )}
          </Subscribe>
        </LayoutContainer>
      )}
    </Location>
  )
}

const withLayout = Child => props => LayoutFactory(Child, props)

export default withLayout
